<template>
  <div v-if="info">
    <h1>{{info.name}}</h1>
    <h2>Всего зарегистрировано: {{ info.registeredCount }}</h2>
    <h2>Претендентов: {{ info.applicantCount }}</h2>
    <p-button type="success" @click="roll">Розыграть приз</p-button>
    <p-button type="danger" @click="reset">Сбросить лотерею</p-button>
    <ul>
      <li v-for="winner in info.activeResult">
        <strong v-if="winner.deleted">НЕ ПРИШЕЛ </strong>
        {{ winner.prize }}: {{ winner.surveyAnswer.barcode }} - {{ winner.surveyAnswer.result.lastName }} {{ winner.surveyAnswer.result.firstName }} - {{ winner.surveyAnswer.result.phone }}    <p-button v-if="!winner.deleted" type="warning" @click="reroll(winner)">Переигровка</p-button>
      </li>
    </ul>
  </div>
<!--  <dashboard-layout>-->
<!--  </dashboard-layout>-->
</template>

<script>
  import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'
  import PButton from '../../UIComponents/Button'
  import swal from 'sweetalert2'


  export default {
    components: {
      PButton,
      DashboardLayout
    },
    name: 'lottery-admin',
    props: {
      lotteryId: {
        type: Number,
        default () {
          return parseInt(this.$route.params.lotteryId)
        }
      }
    },
    data () {
      return {
        info: null,
        results: null,
      }
    },
    async created () {
      try {
        const response = await this.axios.get(`lottery/${this.lotteryId}/`)
        this.info = response.data
        // this.refreshResult()
      } catch (e) {
        console.error(`Не удалось загрузить информацию о лотерее с id ${this.lotteryId}`)
      }
    },
    methods: {
      // async refreshResult () {
      //   try {
      //     const response = await this.axios.get(`lottery/${this.lotteryId}/result/active/`)
      //     this.results = response.data
      //   } catch (e) {
      //     this.results = null
      //   }
      // },
      async roll () {
        try {
          const response = await this.axios.post(`lottery/${this.lotteryId}/roll/`)
          this.info = response.data
        } catch (e) {
          swal({
            title: this.$gettext('Network error!'),
            type: 'error',
            timer: 5000,
            html: this.$gettext('<h4>Try again</h4>'),
            showConfirmButton: false
          })
        }
      },
      async reroll (winner) {
        try {
          const response = await this.axios.post(`lottery/${this.lotteryId}/reroll/`, {
            winnerId: winner.pk
          })
          this.info = response.data
        } catch (e) {
          swal({
            title: this.$gettext('Network error!'),
            type: 'error',
            timer: 5000,
            html: this.$gettext('<h4>Try again</h4>'),
            showConfirmButton: false
          })
        }
      },
      async reset () {
        try {
          const response = await this.axios.post(`lottery/${this.lotteryId}/reset/`)
          this.info = response.data
        } catch (e) {
          swal({
            title: this.$gettext('Network error!'),
            type: 'error',
            timer: 5000,
            html: this.$gettext('<h4>Try again</h4>'),
            showConfirmButton: false
          })
        }
      },
    }
  }
</script>

<style scoped>

</style>
